module.exports = __webpack_public_path__ + "img/all.e22eff75.svg";